import $ from 'jquery';

/**
 * Show invoice fields if invoice payment type selected
 */
class PaymentMethodCheck {
    constructor () {
        this.$paymentMethodFields = $('.js-payment-method-container input');

        this.$paymentMethodFields.on('click', function () {
            const $invoiceForm = $('.js-invoice-details-container');

            if ($(this).val() === 'invoice') {
                $invoiceForm.slideDown();
            } else {
                $invoiceForm.slideUp();
            }
        });
    }
}

export default PaymentMethodCheck;
